import { ContentTag, Obj } from "scrivito"
import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { ProductAttributes } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantAttributes } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"

import { useInstallationReferenceProductInfoViewModel } from "../../installation-reference-product-info/hooks/useInstallationReferenceProductInfoViewModel"
import { InstallationReferenceTabContentProps } from "../InstallationReferenceTabContent"
import { InstallationReferenceTabContentViewModel } from "../InstallationReferenceTabContentView"

export function useInstallationReferenceTabContentViewModel({
  installationReferenceObj
}: InstallationReferenceTabContentProps): InstallationReferenceTabContentViewModel {
  return {
    productInfoViewModel: useInstallationReferenceProductInfoViewModel(
      installationReferenceObj
    ),
    productImage: installationReferenceObj.get("product") ? (
      <ProductImage
        obj={
          installationReferenceObj.get("product") as Obj<
            ProductAttributes | ProductBaseVariantAttributes
          >
        }
      />
    ) : null,
    detailImage: (
      <ContentTag
        content={installationReferenceObj}
        attribute="detailImageWidget"
      />
    ),
    roomImage: (
      <ContentTag
        content={installationReferenceObj}
        attribute="roomImageWidget"
      />
    )
  }
}
